import { AuthUserRoute } from '/@/modules/auth/routes/auth.routes';

export const router = [
  {
    path: AuthUserRoute.USER.path,
    component: () => import('/@/modules/auth/pages/AuthUserPage.vue'),
    children: [
      {
        path: '',
        redirect: AuthUserRoute.PROFILE
      },
      {
        name: AuthUserRoute.PROFILE.name,
        path: AuthUserRoute.PROFILE.path,
        component: () => import('/@/modules/auth/components/AuthUserDashboard.vue')
      }
    ]
  }
];
